import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {HTH} from "../HTH";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameMode} from "../server/HTHGameMode";
import {HTHSound} from "../sound/HTHSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class HTHFSOutro extends PIXI.Container implements StageLayer {
    private _goodSpine: PIXI.spine.Spine;
    private _spinsPlayedText: PIXI.Text;
    private _spinsPlayedNr: PIXI.Text
    private _countUp: BasicBitmapCountUp;
    private _safeContainer1: PIXI.Container;
    private _safeContainer2: PIXI.Container;
    private _blackOverlay: PIXI.Sprite;
    private _outroType: string;
    private _spineMask: PIXI.Sprite | null;

    private _textStyleSpinsPlayedText = new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAngle: 1.7,
        dropShadowBlur: 3,
        dropShadowDistance: 1,
        fill: "#ffffff",
        fontSize: 30,
        fontFamily: "Open Sans",
        fontWeight: "bold",
        stroke: "#000000",
        lineJoin: "round",
        strokeThickness: 7

    })
    private _textStyleSpinsPlayedNum = new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAngle: 1.7,
        dropShadowBlur: 3,
        dropShadowDistance: 1,
        fill: "#ffffff",
        fontSize: 60,
        fontWeight: "bold",
        fontFamily: "Open Sans",
        stroke: "#000000",
        strokeThickness: 7,
        lineJoin: "round"
    })

    constructor() {
        super();
        this.name = "FSOutroView";
        this.init();
    }


    public hideFSOutro(): gsap.core.Timeline {
        const hideFSOuttroTL: gsap.core.Timeline = gsap.timeline();

        hideFSOuttroTL.add(HTH.gameViewContainer.hideOverlay());
        hideFSOuttroTL.to([this, this._spinsPlayedText, this._spinsPlayedNr, this._countUp], {
            alpha: 0,
            duration: 0.3
        }, "<");
        hideFSOuttroTL.add(HTHHelper.playSpineWithTimeline(this._goodSpine, 0, this._outroType === "outrowin" ? this._outroType + "fadeiout" : this._outroType + "fadeout"), "<");
        hideFSOuttroTL.add(() => {
            if (HTH.model.data.nextMode !== HTHGameMode.EXTRA_SPIN) {
                HTH.backgroundElements.setMode(HTH.model.data.nextMode);
            }
            this.visible = false;
            this._goodSpine.visible = this._spinsPlayedNr.visible = this._spinsPlayedText.visible = this._countUp.visible = false;
            if (this._safeContainer1.children.length > 0) {
                this._safeContainer1.children.forEach((item) => {
                    item.destroy();
                })
            }
            if (this._safeContainer2.children.length > 0) {
                this._safeContainer2.children.forEach((safe) => {
                    safe.destroy();
                })
            }
            this._spineMask?.destroy();
            this.removeChild(this._spineMask!);
            this._spineMask = null;
            this._safeContainer1.removeChildren();
            this._safeContainer2.removeChildren();
            this._safeContainer1.alpha = 0;
            this._safeContainer2.alpha = 0;
            HTHHelper.resetSpineItem(this._goodSpine);
        });

        return hideFSOuttroTL;
    }

    public onResize(): void {
        const bounds = NolimitApplication.screenBounds
        this._blackOverlay.width = bounds.width;
        this._blackOverlay.height = bounds.height;
        this._blackOverlay.position.x = bounds.left;
        this._blackOverlay.position.y = bounds.top;
        if (!this.visible) {
            return;
        }

        HTH.gameViewContainer.resetOverlay();
    }

    public showFSOutro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            spinetl: gsap.core.Timeline = gsap.timeline(),
            infotl: gsap.core.Timeline = gsap.timeline(),
            totalWin: number = HTH.model.gameData.accumulatedRoundWin,
            isZeroWin: boolean = (totalWin === 0),
            startPoint: number = 0,
            price: number = HTHHelper.getBuyFeaturePrice(),
            isBadOutro: boolean = totalWin <= price * 1.1;
        // defining new ratio of 1.1 to be treated as bad outro

        this._outroType = isBadOutro ? "outronowin" : "outrowin";
        this.addSpineMsk(isBadOutro ? 0 : 1);

        this.onResize();

        tl.add(HTH.gameViewContainer.addOverlay(0.1, 0.7), 0);
        if (HTH.model.data.nextMode === HTHGameMode.NORMAL) {
            tl.add(HTH.gameViewContainer.scatterCollector.showScatterCollector(false));
        }
        tl.add(() => {
            this._spinsPlayedNr.text = `${HTH.model.gameData.freespinsPlayed}`;
            // this._spinsPlayedNr.position.set(360 - this._spinsPlayedNr.width * 0.5, 450);
            this.visible = true;
            this.alpha = 1;
            this._spinsPlayedText.visible = true;
            this._blackOverlay.visible = true;
            this._blackOverlay.alpha = 0;
            this._spinsPlayedNr.visible = true;
            this._goodSpine.visible = true;
            this._addSafesInOutro();
        }, 0);
        spinetl.add(HTHHelper.playSpineWithTimeline(this._goodSpine, 0, this._outroType + "fadein"), 0);
        spinetl.add(() => {
            this._goodSpine.autoUpdate = true;
            this._goodSpine.state.setAnimation(0, this._outroType + (!isBadOutro ? "fadeinloop" : "loop"), true);
        }, ">");
        infotl.to(this._blackOverlay, {alpha: 0.5, duration: 0.1}, 1);
        infotl.to([this._spinsPlayedNr, this._spinsPlayedText], {
            duration: 0.1,
            alpha: 1
        });
        infotl.to([this._safeContainer1, this._safeContainer2], {
            duration: 0.1,
            alpha: 1
        },);
        if (!isZeroWin) {

            const isWinBelowStake: boolean = HTHHelper.isWinBelowStake();
            const hasCountUp: boolean = !(isWinBelowStake || isBadOutro);
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.alpha = 0;
            this._countUp.visible = true;


            infotl.to(this._countUp, {duration: 0.1, alpha: 1});
            infotl.to(this._countUp.scale, {duration: 0.1, x: 1, y: 1, ease: "sine.in"}, "<");
            infotl.add(this._countUp.getCountAnimation(0, totalWin, hasCountUp ? 1.5 : 0.001), "<");
            if (hasCountUp) {
                infotl.add(() => {
                    HTHSound.playTrack(HTHSound.COUNTUP);
                }, "<");
            }
            infotl.addLabel("countupComplete");

            if (hasCountUp) {
                infotl.add(() => {
                    HTHSound.stopSound(HTHSound.COUNTUP);
                    HTHSound.playTrack(HTHSound.COUNTUP_FS_END_GOOD);
                }, "countupComplete")
            } else {
                infotl.add(() => {
                    HTHSound.playTrack(HTHSound.COUNTUP_FS_END_BAD);
                }, "<")
            }
        }
        tl.add(spinetl, 0);
        tl.add(infotl, 0);

        return tl;
    }

    private init(): void {
        this._blackOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._blackOverlay.name = "blackOverlay";
        this._blackOverlay.alpha = 0.5;
        this._blackOverlay.tint = 0x000000;
        this._blackOverlay.visible = false;


        this._goodSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("fsOutro"));
        this._goodSpine.name = "fsoutro BG spine";
        this.addChild(this._goodSpine);
        this._goodSpine.position.set(377, 360);
        this._goodSpine.visible = false;
        this._goodSpine.scale.set(0.9, 0.9);
        this.addChild(this._blackOverlay);

        this._spinsPlayedText = new PIXI.Text("", this._textStyleSpinsPlayedText);
        this._spinsPlayedText.visible = false;
        this._spinsPlayedText.alpha = 0;
        this._spinsPlayedText.name = "spins Played Text"
        this._spinsPlayedText.anchor.set(0.5);
        this._spinsPlayedText.position.set(360, 500);
        this.addChild(this._spinsPlayedText);

        this._spinsPlayedText.text = HTH.apiPlugin.translations.translate("SPINS PLAYED");


        this._spinsPlayedNr = new PIXI.Text("", this._textStyleSpinsPlayedNum);
        this._spinsPlayedNr.name = "spins played no";
        this._spinsPlayedNr.visible = false;
        this._spinsPlayedNr.alpha = 0;
        this._spinsPlayedNr.anchor.set(0.5);
        this._spinsPlayedNr.position.set(360, 550);
        this.addChild(this._spinsPlayedNr);


        this._countUp = new BasicBitmapCountUp({
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 150);
        this._countUp.name = "countup amount";
        this._countUp.stopAt(0);
        this._countUp.visible = false;
        this.visible = false;
        this.addChild(this._countUp);

        this._safeContainer1 = new PIXI.Container();
        this._safeContainer1.name = "SafeContainer1"
        this._safeContainer1.position.set(360, 300);
        this._safeContainer1.alpha = 0;
        this._safeContainer2 = new PIXI.Container();
        this._safeContainer2.name = "SafeContainer2"
        this._safeContainer2.position.set(360, 420);
        this._safeContainer2.alpha = 0;

        this.addChild(this._safeContainer1, this._safeContainer2);
        this.onResize();
    }

    private _addSafesInOutro() {
        const safesPosition = HTH.model.data.safeSymbols;

        safesPosition.sort((pos1, pos2) => {
            if (pos1.x == pos2.x) {
                return pos1.y - pos2.y;
            }
            return pos1.x - pos2.x;
        });
        const safesNum: number = safesPosition.length;


        if (safesNum === 0) {
            this._countUp.position.set(360, 300);
        } else if (safesNum > 10) {
            this._countUp.position.set(360, 150);
        } else {
            this._countUp.position.set(360, 225);
        }

        let safesCont1: number = 0;
        let safesCont2: number = 0;


        if (safesNum > 10) {
            safesCont1 = Math.floor(safesNum / 2);
            safesCont2 = Math.ceil(safesNum / 2);
        } else {
            safesCont1 = safesNum;
        }

        for (let i = 0; i < safesCont1; i++) {
            const pos = safesPosition[i];
            const saSprite: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("SA/SA")[0]);
            const multi: PIXI.BitmapText = new PIXI.BitmapText("", {
                fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
                fontSize: 11,
                letterSpacing: -35
            })
            saSprite.addChild(multi);
            this._safeContainer1.addChild(saSprite);
            saSprite.anchor.set(0.5, 0.5);

            saSprite.scale.set(0.6, 0.6);
            saSprite.position.set((i - Math.floor(safesCont1 / 2)) * 85, 0);

            multi.text = `x${HTH.model.gameData.sizesAfterAvalanche[pos.x][pos.y]}`;
            multi.anchor = new PIXI.Point(0.5, 0);


            if (multi.width > 100) {
                multi.scale.set(100 / multi.width);
            }
            multi.pivot.set(0, multi.height / multi.scale.x);
            multi.position.set(0, saSprite.height / (2 * 0.6) - 10);

        }

        for (let j = 0; j < safesCont2; j++) {
            const pos = safesPosition[safesCont1 + j - 1];
            const saSprite: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("SA/SA")[0]);
            const multi: PIXI.BitmapText = new PIXI.BitmapText("", {
                fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
                fontSize: 11,
                letterSpacing: -35
            })
            saSprite.addChild(multi);
            this._safeContainer2.addChild(saSprite);

            saSprite.anchor.set(0.5, 0.5);
            saSprite.scale.set(0.6, 0.6);
            saSprite.position.set((j - Math.floor(safesCont2 / 2)) * 85, 0);
            multi.text = `x${HTH.model.gameData.sizesAfterAvalanche[pos.x][pos.y]}`;
            multi.anchor = new PIXI.Point(0.5, 0);

            if (multi.width > 100) {
                multi.scale.set(100 / multi.width);
            }
            multi.pivot.set(0, multi.height / multi.scale.x);
            multi.position.set(0, saSprite.height / (2 * 0.6) - 10);

        }
        if (safesNum <= 10) {
            this._safeContainer1.position.set(360, 420);
        }

        if (safesCont1 % 2 == 0) {
            this._safeContainer1.pivot.x = -40;
        } else {
            this._safeContainer1.pivot.x = 0;
        }

        if (safesCont2 % 2 == 0) {
            this._safeContainer2.pivot.x = -40;
        } else {
            this._safeContainer2.pivot.x = 0;
        }


    }

    private addSpineMsk(type: number): void {
        this._spineMask = new PIXI.Sprite(HTH.assetLoader.getTextures(type === 0 ? "outroMaskBad" : "outroMaskGood")[0]);
        this._spineMask.position.set(360, 360);
        this._spineMask.anchor.set(0.5, 0.5);
        this._spineMask.name = "edgy_mask_outro";
        this.addChild(this._spineMask);
        this._goodSpine.mask = this._spineMask;
    }
}